import { AUTH_ME, SIGNIN, JOIN_USER, GET_NOTIFICATION_COUNT } from '../../../apiService/apiDeclaration';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getLoggedInUser = createAsyncThunk('auth/getLoggedInUser', AUTH_ME);

export const signIn = createAsyncThunk('auth/signInUser', SIGNIN);
export const join = createAsyncThunk('auth/joinUser', JOIN_USER);
export const notification = createAsyncThunk('auth/getCountNotification', GET_NOTIFICATION_COUNT);
